
      const plausibleDomain = import.meta.env.VITE_PLAUSIBLE_DOMAIN;
      const script = document.createElement('script');
      script.defer = true;
      script.setAttribute('data-domain', plausibleDomain);
      script.src = "https://plausible-analytics.aws.sa.vallourec.com/js/script.file-downloads.hash.outbound-links.pageview-props.tagged-events.js";
      document.head.appendChild(script);
      window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) };
    